import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { useInstance, createRef, findDomFromVNode, onMounted, onBeforeUnmount } from 'intact-vue';
import { useState } from '../../hooks/useState';
import ResizeObserver from 'resize-observer-polyfill';
import { nextFrame } from '../utils';
export function useSlide(getItems, getItemsWithCloned) {
  var instance = useInstance();
  var translate = useState(0);
  var shouldTransition = useState(true);
  var elementRef = createRef();
  var ro = null;
  function observe() {
    var init = function init() {
      setTranslate(getItems()[instance.getIndex()], false);
    };
    ro = new ResizeObserver(init);
    ro.observe(elementRef.value);
    init();
  }
  function disconnect() {
    if (ro) {
      ro.disconnect();
      ro = null;
    }
  }
  function stopTranstion() {
    shouldTransition.set(false);
  }
  function startTransition() {
    return new _Promise(function (resolve) {
      nextFrame(function () {
        shouldTransition.set(true);
        resolve();
      });
    });
  }
  function translateToItem(_x, _x2, _x3, _x4) {
    return _translateToItem.apply(this, arguments);
  }
  function _translateToItem() {
    _translateToItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, oldIndex, newIndex, keepDirection) {
      var itemsWithCloned, length, lengthWithCloned;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isSlide()) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (!keepDirection) {
              _context.next = 14;
              break;
            }
            itemsWithCloned = getItemsWithCloned();
            length = getItems().length;
            if (!(oldIndex === length - 1 && newIndex === 0)) {
              _context.next = 10;
              break;
            }
            _context.next = 8;
            return setTranslate(itemsWithCloned[(itemsWithCloned.length - length) / 2 - 1], false);
          case 8:
            _context.next = 14;
            break;
          case 10:
            if (!(oldIndex === 0 && newIndex === length - 1)) {
              _context.next = 14;
              break;
            }
            lengthWithCloned = itemsWithCloned.length;
            _context.next = 14;
            return setTranslate(itemsWithCloned[lengthWithCloned - (lengthWithCloned - length) / 2], false);
          case 14:
            setTranslate(item, true);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _translateToItem.apply(this, arguments);
  }
  function setTranslate(_x5, _x6) {
    return _setTranslate.apply(this, arguments);
  }
  function _setTranslate() {
    _setTranslate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item, withTranstion) {
      var el, offsetLeft, width, containerWidth;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!instance.$unmounted) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            if (!withTranstion) {
              stopTranstion();
            }
            el = findDomFromVNode(item, true);
            offsetLeft = el.offsetLeft;
            width = el.offsetWidth;
            containerWidth = elementRef.value.offsetWidth; // let item position center
            translate.set(-(offsetLeft - (containerWidth - width) / 2));
            if (withTranstion) {
              _context2.next = 11;
              break;
            }
            _context2.next = 11;
            return startTransition();
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _setTranslate.apply(this, arguments);
  }
  function isSlide() {
    return instance.get('effect') === 'slide';
  }
  instance.watch('effect', function () {
    if (isSlide()) {
      observe();
    } else {
      disconnect();
    }
  }, {
    presented: true,
    inited: true
  });
  instance.watch('clonedAmount', function () {
    if (isSlide()) {
      observe();
    }
  }, {
    presented: true,
    inited: true
  });
  onMounted(function () {
    if (isSlide()) {
      observe();
    }
  });
  onBeforeUnmount(disconnect);
  return {
    translate: translate,
    shouldTransition: shouldTransition,
    elementRef: elementRef,
    translateToItem: translateToItem,
    isSlide: isSlide
  };
}